import React, { Component } from 'react';
import AppBar from './AppBar';
import VirtualizedList from './VirtualizedList';
import { IPedido, IFarm, IFilter } from '../types';
import SearchField from './SearchField';
import OrderService from '../ApiClients/OrderService';
import PedidoListItem from './PedidoListItem';
import Loader from './Loader';
import { CheckNumberPlate, searchPedidos } from '../helpers';
import {cloneDeep, filter, find, findIndex, includes} from 'lodash';
import { SwitchField } from './FormsWidgets';
import { Box, Tab, Tabs, Select, InputLabel, MenuItem, SelectChangeEvent, FormControl } from '@mui/material';
import { withParamsAndNavigate } from './Material/ReactRouter';
import CreateModal from './CreateDialog';
import DeliveryDialog from './DeliveryDialog';
import { relative } from 'path';

interface IPedidosProps {
    params?:any;
    navigate?:any;    
    type: number;
    title: string;
    filters: IFilter;
    handleChangeFilter: Function;
}

interface IPedidosState {
    pedidos?: Array<IPedido>;
    searchValue: string;
    loading: boolean;
    filteredPedidos: Array<IPedido>;
    filterPage: Object;
    tabPedidos: number;

    openDeliveryDialog: boolean;
    inputDeliveryDialog: any;
    titleModal: string;
    loadingModal: boolean;
    modalType: number;
    typeAction: number;
    inputText: string;
    creationModalOpen: boolean;

    tPedido?:IPedido;

    pendientes:boolean;
    firstView:boolean;
    plate:string;
    inset_content:string;
    filter_id: string;
}

class Pedidos extends Component<IPedidosProps, IPedidosState> {
    constructor(props: IPedidosProps) {
        super(props);
        this.state = {
            pedidos: undefined,
            filteredPedidos:[],
            searchValue: '',
            loading: true,
            filterPage: {historic: false},
            tabPedidos: 0,

            openDeliveryDialog: false,
            inputDeliveryDialog: '',
            titleModal: 'MENSAJE',
            loadingModal: false,
            modalType: 0,
            typeAction: 0,
            creationModalOpen: false,
            inputText: '',

            pendientes:true,
            plate:'',
            firstView:true,
            inset_content:'60px 0 0',
            filter_id: "f_do"
        };
    }
   
    onCloseCreationModal = () => {
        this.setState({ creationModalOpen: false });
    }

    onCloseDeliveryDialog = () => {
        this.setState({ openDeliveryDialog: false });
    }

    componentDidMount() {
        this.loadPedidos();
    }

    componentWillReceiveProps(nextProps: IPedidosProps) {
        // Si cambia el tipo de pedido, necesitamos recargar
        if (nextProps.type !== this.props.type) {
            this.setState({ 
                loading: true 
            }, () => this.loadPedidos());
        }
    }

    handleChangeFilter=(id:string, evt:any)=>{
        let newFilters = cloneDeep(this.props.filters[this.state.filter_id]);
        newFilters[id] = evt.target.value;

        this.props.handleChangeFilter(this.state.filter_id, newFilters, false);
    }

    loadPedidos = async () => {
        // Usar patrón como Farms: OrderService maneja la cache internamente
        let pedidos = await OrderService.getPedidos(false, this.props.type);
        
        if (pedidos !== undefined) {
            this.setState({
                pedidos,
                loading: false,
                searchValue: ('searchbar' in this.props.filters[this.state.filter_id])? this.props.filters[this.state.filter_id]['searchbar'] : '',
                plate: ('deliveryTruckNumberplate' in this.props.filters[this.state.filter_id])? this.props.filters[this.state.filter_id]['deliveryTruckNumberplate'] : '',
                firstView: !('deliveryTruckNumberplate' in this.props.filters[this.state.filter_id]),
            }, ()=>{
                this.handleFilterPedidos();
            });
        } else {
            this.setState({ loading: false });
        }
    }

    loadPedidosWithRefresh = async () => {
        // Forzar refresh desde servidor después de editar
        let pedidos = await OrderService.getPedidos(true, this.props.type);
        
        if (pedidos !== undefined) {
            this.setState({
                pedidos,
                loading: false,
                searchValue: ('searchbar' in this.props.filters[this.state.filter_id])? this.props.filters[this.state.filter_id]['searchbar'] : '',
                plate: ('deliveryTruckNumberplate' in this.props.filters[this.state.filter_id])? this.props.filters[this.state.filter_id]['deliveryTruckNumberplate'] : '',
                firstView: !('deliveryTruckNumberplate' in this.props.filters[this.state.filter_id]),
            }, ()=>this.handleFilterPedidos());
        }
    }

    handleValueChange = (evt: any) => {
        // Guardar filtro en estado global como hacen Farms y Products
        let newFilters = cloneDeep(this.props.filters[this.state.filter_id]);
        newFilters["searchbar"] = evt.target.value;

        this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

        this.setState({ 
            searchValue: evt.target.value,
        }, ()=>this.handleFilterPedidos())
    }

    handleFilterPedidos = () => {
        // Solo filtrar si hay datos cargados
        if (this.state.pedidos === undefined) {
            return;
        }
        
        let newPedidos = cloneDeep(this.state.pedidos);               
        //** FILTRA POR EL TIPO DE PEDIDO */
        const tipo = this.props.type;
        const tabPedidos = this.state.tabPedidos;
        let newFilters = cloneDeep(this.props.filters[this.state.filter_id]);
        this.setState({pendientes: tabPedidos === 
            0, inset_content: (tabPedidos === 0) ? '60px 0 0': '0 0 0'});
        
        if(tipo === 1 && tabPedidos === 0) {
            newPedidos = filter(newPedidos, function(o) {return ![50, 98, 99].includes(o.status)})
        } else if(tipo === 2 && tabPedidos === 0) {
            newPedidos = filter(newPedidos, function(o) {return ![50, 98, 99].includes(o.status)})
    
            //** FILTRA POR EL VALOR DE MATRÍCULA */
            const plate = this.state.plate;
            
            newFilters["deliveryTruckNumberplate"] = plate;

            this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

            if(newPedidos.length > 0 && plate && plate !== 'Matrícula sin asignar'){
                newPedidos = filter(newPedidos, function(o){return includes(o.deliveryTruckNumberplate, plate)});
            }else if(plate === 'Matrícula sin asignar'){            
                newPedidos = filter(newPedidos, function(o){return o.deliveryTruckNumberplate === ""});
            }
        }
                
        //** FILTRA POR EL VALOR DE BÚSQUEDA */
        const searchValue = this.state.searchValue.toLowerCase();
        
        newFilters["searchbar"] = searchValue;

        this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

        if(newPedidos.length > 0 && searchValue && searchValue.length > 0){
            newPedidos = filter(newPedidos, function(o){return includes(o.farm?.id.toLowerCase(), searchValue) || includes(o.farm?.name.toLowerCase(), searchValue) || includes(o.idPedido?o.idPedido.toLowerCase():"", searchValue) });
        }

        this.setState({
            filteredPedidos: newPedidos
        })
    }

    handleItemClick = (pedido: IPedido, i: number) => {
        const pedidoRef = (pedido as any).idPedido ?? String((pedido as any).id ?? '');
        if(this.props.type === 1)
            this.props.navigate(`/pedido/${pedido.business}/${pedidoRef}`);
        else if(this.props.type === 2)
            this.props.navigate(`/delivery/${pedido.business}/${pedidoRef}`);
    }

    handleItemEditClick = (e: any, pedido: IPedido, i: number) => {
        e.stopPropagation();

        this.setState({
            tPedido: pedido
        }, ()=>this.handleEditPedido())
    }

    handleEditPedido = () => {
        if(!this.state.tPedido)
            return;

        let n_pedido = cloneDeep(this.state.tPedido);

        n_pedido.handleChange = (id: string, evt: any) => this.handleHeaderChange(id, evt, n_pedido);


        this.setState({
            titleModal:'EDICIÓN DATOS',
            inputDeliveryDialog: <DeliveryDialog style={{}} index={-1} data={[2, n_pedido]} />,
            modalType: 5,
            typeAction: 1,
            openDeliveryDialog: true
        })
    }

    handleHeaderChange = (id: string, evt: any, pedido:IPedido) => {
        let n_pedido = cloneDeep(pedido);
        n_pedido[id] = evt.target.value;

        if(id === "deliveryTruckNumberplate" || id === "deliveryTrailerNumberplate")
            n_pedido[id] = n_pedido[id]?.trim().toUpperCase();

        this.setState({
            tPedido: n_pedido
        }, ()=>this.handleEditPedido())
    }

    saveEditPedido = async () => {
        const {tPedido} = this.state;
        // Verifica que la tienda y la fecha del carrito no sean undefined
        if(tPedido && tPedido.farm && tPedido.date && tPedido.id) {
            let Pedido: IPedido = cloneDeep(tPedido);

            let responsePedido : number = await OrderService.saveData(Pedido, 3);

            let text = "¡ATENCIÓN! Se ha producido un error y no se han podido actualizar los datos del pedido.";
            let modalType = 1;
            let typeAction = -1;

            switch(responsePedido){ // Condicional para verificar que no ha habido ningun error en el backend
                case 1:
                    text = "Se ha actualizado correctamente.";
                    modalType = 1;
                    typeAction = 0;

                    // Forzar recarga de datos después de editar
                    this.setState({
                        inputText: text,
                        modalType: modalType,
                        creationModalOpen: true,
                        typeAction:typeAction,
                        loadingModal: false,
                        openDeliveryDialog: false,
                        loading: true,
                        pedidos: undefined  // Forzar nueva petición
                    });
                    // Forzar refresh en OrderService para obtener datos actualizados del servidor
                    this.loadPedidosWithRefresh();
                    break;
                default: 
                    this.setState({
                        inputText: text,
                        modalType: modalType,
                        creationModalOpen: true,
                        typeAction:typeAction,
                        loadingModal: false,
                        openDeliveryDialog: false,
                    })
                    break;
            }

        } 
    }

    handleCreateModal = (typeAction: number) => {
        switch(typeAction) {
            case 1: // Cuando el modal es para abrir el modal de actualizar datos
                const {tPedido} = this.state;

                if(tPedido && tPedido.farm){
                    // Controla los campos obligatorios
                    if(!tPedido.deliveryTruckNumberplate || !CheckNumberPlate(1, tPedido.deliveryTruckNumberplate))
                        this.setState({
                            inputText: `¡ATENCIÓN! Tiene que informar una matrícula de camión válida.`,
                            modalType: 1,
                            creationModalOpen: true,
                            typeAction: -1
                        })
                    else if(!tPedido.deliveryTrailerNumberplate || !CheckNumberPlate(2, tPedido.deliveryTrailerNumberplate))
                        this.setState({
                            inputText: `¡ATENCIÓN! Tiene que informar una matrícula de remolque válida.`,
                            modalType: 1,
                            creationModalOpen: true,
                            typeAction: -1
                        })
                    else
                    this.setState({
                        inputText: `¿Quiere actualizar los datos del pedido de la granja ${tPedido.farm.name}?`,
                        modalType: 2,
                        creationModalOpen: true,
                        typeAction: 2
                    })
                }
                break;
            case 2: // Cuando el modal es para guardar los datos actualizados
                this.setState({
                    loadingModal: true
                }, ()=>this.saveEditPedido())
                break;
            default:
                break;
        }
    }
    

    handleChangePlate = (event: SelectChangeEvent) => {      
        // Solo filtrar si hay datos cargados
        if (this.state.pedidos === undefined) {
            return;
        }
                  
        let newPedidos = cloneDeep(this.state.pedidos);
        const searchValue = event.target.value;

        let newFilters = cloneDeep(this.props.filters[this.state.filter_id]);
        newFilters["deliveryTruckNumberplate"] = searchValue;

        this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

        if(newPedidos.length > 0 && searchValue && searchValue !== 'Matrícula sin asignar'){
            newPedidos = filter(newPedidos, function(o){return includes(o.deliveryTruckNumberplate, searchValue)});
        }else if(searchValue === 'Matrícula sin asignar'){            
            newPedidos = filter(newPedidos, function(o){return o.deliveryTruckNumberplate === ""});
        }

        this.setState({
            filteredPedidos: newPedidos,
            plate: searchValue, 
            firstView: false
        }, ()=>this.handleFilterPedidos())
    };

    renderPedidos=(type:number)=>{
        if(this.state.loading){
            return(
                <div style={{marginLeft:'50%',marginTop:200}}>
                    <Loader loading={true}/>
                </div>
            );
        }
        else if(type === 1) {
            const {filteredPedidos} = this.state;
            if(filteredPedidos.length === 0) {
                return (
                    <div style={{textAlign:'center', padding:50}}>
                        <p>
                            {`No tiene pedidos realizados para visualizar.`}
                        </p>
                    </div>
                )
            }
            let items = filteredPedidos.map((pedido, i) => {
                return {
                    ...pedido,
                    onItemClick: () => this.handleItemClick(pedido, i),
                }
            })
            return(
                <VirtualizedList items={items} RowComponent={PedidoListItem} itemSize={150} />
            );
        }
        else if(type === 2) {
            const {filteredPedidos} = this.state;
            let items = filteredPedidos.map((pedido, i) => {
                return {
                    ...pedido,
                    onItemClick: () => this.handleItemClick(pedido, i),
                    onItemEditClick: (e:any) => this.handleItemEditClick(e, pedido, i),
                }
            })
            
            // Verificar que pedidos no sea undefined antes de hacer map
            let plates: string[] = [];
            if (this.state.pedidos !== undefined) {
                plates = this.state.pedidos.map((item: IPedido, i: number) => {
                    return item.deliveryTruckNumberplate === "" ? "Matrícula sin asignar" : (item.deliveryTruckNumberplate || "");
                });
            }
            let numberPlates = plates.filter((plate, index) => plates.indexOf(plate) === index);
            
            if(filteredPedidos.length === 0) {
                if(this.state.tabPedidos === 0){
                    return(
                        <div style={{ marginLeft:'10px' }}>{(this.state.pendientes) ?
                            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} style={{ marginLeft:'10px', marginTop:'5px' }}>
                                <InputLabel id="matricula-label">Matrícula</InputLabel>
                                <Select labelId="matricula-label" id="matricula" value={(numberPlates.length === 1) ? numberPlates[0]: this.state.plate} onChange={this.handleChangePlate} label="Matrícula"> 
                                {/* <MenuItem value="todos">Mostrar todas</MenuItem>                      */}
                                {numberPlates.map((item, i) =>{                            
                                        return <MenuItem value={item}>{item}</MenuItem>;
                                })}                    
                                </Select>
                            </FormControl> : null
                            }                    
                            <div style={{ position:'absolute', inset: this.state.inset_content }}>
                            <div style={{textAlign:'center', padding:50}}>
                                <p>
                                    {`No tiene pedidos pendientes de entregar para visualizar.`}
                                </p>
                            </div>
                            </div>
                        </div>
                    );
                }else if(this.state.tabPedidos === 1)
                    return (
                        <div style={{textAlign:'center', padding:50}}>
                            <p>
                                {`No tiene pedidos pendientes de entregar o entregados para visualizar.`}
                            </p>
                        </div>
                    )
                else
                    return (
                        <div style={{textAlign:'center', padding:50}}>
                            <p>
                                {`No hay datos a visualizar.`}
                            </p>
                        </div>
                    )
            }

            
            if (this.state.firstView && numberPlates.length > 1){       
                return(
                        <div>{
                            (this.state.pendientes) ?
                            <div style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)' }}>
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                    <InputLabel id="matricula-label">Matrícula</InputLabel>
                                    <Select labelId="matricula-label" id="matricula" value={this.state.plate} onChange={this.handleChangePlate} label="Matrícula">
                                            {numberPlates.map((item, i) =>{                            
                                                return <MenuItem value={item}>{item}</MenuItem>;
                                                })}                    
                                    </Select>
                                </FormControl>
                            </div> : 
                            <div style={{ position:'absolute', inset: this.state.inset_content }}>
                                <VirtualizedList items={items} RowComponent={PedidoListItem} itemSize={170} />
                            </div>
                        }</div>
                        
                    );
            }else{
                return(
                    <div style={{ marginLeft:'10px' }}>{(this.state.pendientes) ?
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} style={{ marginLeft:'10px', marginTop:'5px' }}>
                            <InputLabel id="matricula-label">Matrícula</InputLabel>
                            <Select labelId="matricula-label" id="matricula" value={(numberPlates.length === 1) ? numberPlates[0]: this.state.plate} onChange={this.handleChangePlate} label="Matrícula"> 
                            {numberPlates.map((item, i) =>{                            
                                    return <MenuItem value={item}>{item}</MenuItem>;
                            })}                    
                            </Select>
                        </FormControl> : null
                        }                    
                        <div style={{ position:'absolute', inset: this.state.inset_content }}>
                            <VirtualizedList items={items} RowComponent={PedidoListItem} itemSize={170} />
                        </div>
                    </div>
                );
            }
            
        }
    }

    handleSwichChangeUser=(id:string, evt:any)=>{
        let newRegister:any = cloneDeep(this.state.filterPage);
        newRegister[id] = evt.target.checked;
        this.setState({filterPage:newRegister});
    }

    handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        this.setState({
            tabPedidos: newValue
        }, ()=>this.handleFilterPedidos())
    };

    render() {

        const {type, title} = this.props;
        const {tabPedidos} = this.state;

        return (
            <AppBar title={title} navigate={this.props.navigate}>
                {/* <div style={{ paddingTop: '10px' }}>
                    <SearchField allowSearch={this.state.loading} value={this.state.searchValue} onValueChange={this.handleValueChange} placeholder="Buscar Pedido" />
                </div> */}
                <div style={{ paddingTop: '15px' }}>
                    <table style={{width:'100%'}}>
                        <tbody>
                            <tr>
                                <SearchField allowSearch={this.state.loading} value={this.state.searchValue} onValueChange={this.handleValueChange} placeholder="Buscar Pedido" />                            </tr>
                            <tr>
                                <td>
                                    
                                    <Box sx={{ maxWidth: { xs: 320, sm: 480 }, bgcolor: 'background.paper', marginLeft: '10px', marginTop: '5px' }}>
                                        <Tabs
                                            value={tabPedidos}
                                            onChange={this.handleChangeTab}
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            aria-label="scrollable auto tabs example"
                                        >
                                            <Tab label={`Pendientes`} />
                                            <Tab label={`Todos`} />
                                        </Tabs>
                                    </Box>
                                    {/* <SwitchField
                                        key={0}
                                        name={`historic`}
                                        id={`historic`}
                                        fieldsData={filterPage}
                                        handleFieldChange={this.handleSwichChangeUser}
                                        disabled={false}
                                        color="secondary"
                                    />
                                    {`Histórico`} */}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style={{
                    position: 'absolute',
                    top: 130,
                    left: 0,
                    right: 0,
                    bottom: 0,
                }}>
                    {this.renderPedidos(type)}
                </div>

                {this.state.openDeliveryDialog?
                    <CreateModal
                        onCloseCreationModal={this.onCloseDeliveryDialog}
                        isOpen={this.state.openDeliveryDialog}
                        inputText={this.state.inputDeliveryDialog}
                        typeModal={this.state.modalType}
                        action={this.handleCreateModal}
                        typeAction={this.state.typeAction}
                        loadingModal={this.state.loadingModal}
                        titleModal={this.state.titleModal}
                        zIndex={0}
                    />
                :
                    null
                }
                {this.state.creationModalOpen?
                    <CreateModal
                        onCloseCreationModal={this.onCloseCreationModal}
                        isOpen={this.state.creationModalOpen}
                        inputText={this.state.inputText}
                        typeModal={this.state.modalType}
                        action={this.handleCreateModal}
                        typeAction={this.state.typeAction}
                        loadingModal={this.state.loadingModal}
                        titleModal={this.state.titleModal}
                        zIndex={99}
                    />
                :
                    null
                }
            </AppBar>
        );
    }
}
export default withParamsAndNavigate(Pedidos);